import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    themedata: any;
    regionList = [
        {
            code: "USA",
            name: "USA",
            routerLink: "https://vmanico.com/"
        },
        {
            code: "INDIA",
            name: "India",
            routerLink: "https://vmanico.in/"
        }
    ];
    private fonts = [
        {
            name: 'small',
        },
        {
            name: 'medium',
        },
        {
            name: 'large',
        }
    ];

    private themeSubject: BehaviorSubject<any>;
    theme$: Observable<any>;

    private _selectedFont: BehaviorSubject<any> = new BehaviorSubject<any>(this.fonts[1]);
    selectedFont$ = this._selectedFont.asObservable();

    _selectedRegion: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selectedRegion$ = this._selectedRegion.asObservable();

    constructor(
        private cookieService: CookieService,
    ) {
        const initialTheme = this.checkCookies();
        this.themeSubject = new BehaviorSubject<any>(initialTheme);
        this.theme$ = this.themeSubject.asObservable();

        this.applyTheme(initialTheme);

        const storedFont = this.cookieService.get('font');
        if (storedFont) {
            const font = JSON.parse(storedFont);
            this._selectedFont.next(font);
        }

        const storedRegion = this.cookieService.get('region');
        if (storedRegion) {
            this._selectedRegion.next(storedRegion);
        } else {
            this.cookieService.set('region', environment.DEFAULT_REGION, 365, '/');
            this._selectedRegion.next(environment.DEFAULT_REGION);
        }
    }

    setFontSize(fontName: string): void {
        const font = this.fonts.find(font => font.name === fontName);
        if (font) {
            this.cookieService.set('font', JSON.stringify(font), 365, '/');
            this._selectedFont.next(font);
        }
    }

    setTheme(theme: string): void {
        const newTheme = this.getThemeData(theme);
        this.cookieService.set('theme', theme, 365, '/');
        this.themeSubject.next(newTheme);
    }

    setRegion(regionCode: any) {
        this.cookieService.delete('region', '/');
        this.cookieService.set('region', regionCode, 365, '/');
        this._selectedRegion.next(regionCode);
    }

    private checkCookies(): any {
        const themeFromCookie = this.cookieService.get('theme');

        if (!themeFromCookie) {
            this.cookieService.set('theme', 'blue', 365, '/');
            return this.getThemeData('blue');
        }
        return this.getThemeData(themeFromCookie);
    }

applyTheme(theme: any) {
  document.documentElement.style.setProperty('--primary-bg', theme.primarybg);
  document.documentElement.style.setProperty('--secondary-bg', theme.secondarybg);
  document.documentElement.style.setProperty('--primary-theme', theme.primarytheme);
  document.documentElement.style.setProperty('--card-text', theme.cardtext);
  document.documentElement.style.setProperty('--header', theme.header);
  document.documentElement.style.setProperty('--sub-header', theme.subHeader);
  document.documentElement.style.setProperty('--link', theme.link);
  document.documentElement.style.setProperty('--hover-color', theme.hovercolor);
  document.documentElement.style.setProperty('--footer', theme.footer);
}


    private getThemeData(theme: string): any {
        if (theme === "black") {
            this.themedata = {
                "header": "#030303",
                "subHeader": "#5c5c5c",
                "primarybg": "#272727",
                "secondarybg": "#2b2b2b",
                "nav_menu": "dbf6fd",
                "color": "#fff",
                "cardfont": '#000',
                "cardtext": "#fff",
                "link": "#fff",
                "searchborder": "#fff",
                "searchtext": "#fff",
                "cardbutton": "#000",
                "secondarycolor": "#fff",
                "primarytheme": "#00C8FF",
                "cardbg": "#fff",
                "gradient1": "#353535",
                "gradient2": "#353535",
                "secondarygradient1": "#27bfe9",
                "secondarygradient2": "#27bfe9",
                "hovercolor": "#fff",
                "secondaryhovercolor": "#000",
                "teamcolorcard": "#272727",
                "teamcolor": "#fff",
                "colorheading": '#27bfe9',
                "planheadinghover": "#272727",
                "plandatahover": "#fff",
                'planbuttontexthovercolor': "#272727",
                'footer': '#2b2b2b',
                "theme": "t01",
                "colors": {
                    "let": "red",
                    "get": "yellow",
                    "module": "yellow",
                    "function": "cyan",
                    "if": "orange",
                    "else": "orange",
                    "return": "yellow",
                    "const": "red",
                    "var": "red",
                    "for": "orange",
                    "while": "orange",
                    "switch": "orange",
                    "case": "orange",
                    "break": "orange",
                    "continue": "orange",
                    "true": "yellow",
                    "false": "yellow",
                    "null": "yellow",
                    "undefined": "yellow",
                    "&lt;": "red",
                    "&gt;": "red",
                    "create": "cyan",
                    "object": "cyan",
                    "as": "cyan",
                    "freetext": "cyan",
                },
            }
        }
        else if (theme === "" || theme === "blue") {
            this.themedata = {
                "header": "#73d5f8",
                "subHeader": "#dbf6fd",
                "primarybg": "#f1f6fb",
                "secondarybg": "#dbf6fd",
                "color": "#070c14",
                "cardfont": '#000',
                "cardtext": "#000",
                "searchborder": "#000",
                "searchtext": "#000",
                "link": "#000",
                "cardbutton": "#000",
                "secondarycolor": "#070c14",
                "primarytheme": "#73d5f8",
                "cardbg": "#fff",
                "gradient1": "#6fc2e1",
                "gradient2": "#a8e6f9",
                "secondarygradient1": "#6fc2e1",
                "secondarygradient2": "#a8e6f9",
                "hovercolor": "#070c14",
                "secondaryhovercolor": "#070c14",
                "teamcolorcard": "#73d5f8",
                "teamcolor": "#070c14",
                "colorheading": '#070c14',
                "planheadinghover": "#070c14",
                "plandatahover": "#070c14",
                'planbuttontexthovercolor': "#070c14",
                'footer': '#102e46',
                "theme": "t02",
                "colors": {
                    "let": "red",
                    "get": "red",
                    "module": "blue",
                    "function": "purple",
                    "if": "orange",
                    "else": "orange",
                    "return": "purple",
                    "const": "red",
                    "var": "red",
                    "for": "orange",
                    "while": "orange",
                    "switch": "orange",
                    "case": "orange",
                    "break": "orange",
                    "continue": "orange",
                    "true": "brown",
                    "false": "brown",
                    "null": "brown",
                    "undefined": "brown",
                    "&lt;": "red",
                    "&gt;": "red",
                    "create": "blue",
                    "object": "brown",
                    "as": "purple",
                    "freetext": "brown",
                },
            }
        }
        else if (theme === "purple") {
            this.themedata = {
                "header": "#3e327a",
                "subHeader": "#1a1534",
                "primarybg": "#f5f1fb",
                "secondarybg": "#1a1534",
                "color": "#1a1534",
                "cardtext": "#000",
                "cardfont": '#000',
                "searchborder": "#fff",
                "link": "#000",
                "searchtext": "#fff",
                "cardbutton": "#000",
                "secondarycolor": "#fff",
                "primarytheme": "#b59ded",
                "cardbg": "#fff",
                "gradient1": "#b59ded",
                "gradient2": "#b59ded",
                "secondarygradient1": "#b59ded",
                "secondarygradient2": "#b59ded",
                "hovercolor": "#1a1534",
                "secondaryhovercolor": "#000",
                "teamcolorcard": "#b59ded",
                "teamcolor": "#1a1534",
                "colorheading": '#1a1534',
                "planheadinghover": "#1a1534",
                "plandatahover": "#1a1534",
                'planbuttontexthovercolor': "#1a1534",
                'footer': '#1a1534',
                "theme": "t03",
                "colors": {
                    "let": "green",
                    "get": "yellow",
                    "module": "blue",
                    "function": "purple",
                    "if": "orange",
                    "else": "orange",
                    "return": "purple",
                    "const": "red",
                    "var": "red",
                    "for": "orange",
                    "while": "orange",
                    "switch": "orange",
                    "case": "orange",
                    "break": "orange",
                    "continue": "orange",
                    "true": "brown",
                    "false": "brown",
                    "null": "brown",
                    "undefined": "brown",
                    "&lt;": "red",
                    "&gt;": "red",
                    "create": "blue",
                    "object": "brown",
                    "as": "purple",
                    "freetext": "brown",
                },
            }
        }
        else if (theme === "darkblue") {
            this.themedata = {
                "header": "#5661e6",
                "subHeader": "#7077c2",
                "primarybg": "#faf5ee",
                "secondarybg": "#d3d9ee",
                "color": "#291854",
                "cardfont": '#000',
                "cardtext": "#fff",
                "cardbutton": "#000",
                "searchborder": "#000",
                "link": "#fff",
                "searchtext": "#000",
                "secondarycolor": "#291854",
                "primarytheme": "#5045e6",
                "cardbg": "#fff",
                "gradient1": "#5045e6",
                "gradient2": "#5045e6",
                "secondarygradient1": "#5045e6",
                "secondarygradient2": "#5045e6",
                "hovercolor": "#fff",
                "secondaryhovercolor": "#fff",
                "teamcolorcard": "#291854",
                "teamcolor": "#fff",
                "colorheading": '#fff',
                "planheadinghover": "#fff",
                "plandatahover": "#fff",
                'planbuttontexthovercolor': "#291854",
                'footer': '#291854',
                "theme": "t04",
                "colors": {
                    "let": "orange",
                    "get": "yellow",
                    "module": "yellow",
                    "function": "purple",
                    "if": "orange",
                    "else": "orange",
                    "return": "purple",
                    "const": "red",
                    "var": "red",
                    "for": "orange",
                    "while": "orange",
                    "switch": "orange",
                    "case": "orange",
                    "break": "orange",
                    "continue": "orange",
                    "true": "brown",
                    "false": "brown",
                    "null": "brown",
                    "undefined": "brown",
                    "&lt;": "red",
                    "&gt;": "red",
                    "create": "blue",
                    "object": "brown",
                    "as": "purple",
                    "freetext": "brown",
                },
            }
        }
        else if (theme === "yellow") {
            this.themedata = {
                "header": "#dbd2b2",
                "subHeader": "#f2ecd7",
                "primarybg": "#faf5ee",
                "secondarybg": "#f2ecd7",
                "color": "#2e2710",
                "cardfont": '#000',
                "cardtext": "#000",
                "cardbutton": "#000",
                "searchborder": "#000",
                "searchtext": "#000",
                "link": "#000",
                "secondarycolor": "#2e2710",
                "primarytheme": "#fece5f",
                "cardbg": "#fff",
                "gradient1": "#fece5f",
                "gradient2": "#fece5f",
                "secondarygradient1": "#fece5f",
                "secondarygradient2": "#fece5f",
                "hovercolor": "#2e2710",
                "secondaryhovercolor": "#2e2710",
                "teamcolorcard": "#2e2710",
                "teamcolor": "#fff",
                "colorheading": '#2e2710',
                "planheadinghover": "#2e2710",
                "plandatahover": "#2e2710",
                'planbuttontexthovercolor': "#2e2710",
                'footer': '#291854',
                "theme": "t05",
                "colors": {
                    "let": "red",
                    "get": "red",
                    "module": "blue",
                    "function": "purple",
                    "if": "orange",
                    "else": "orange",
                    "return": "purple",
                    "const": "red",
                    "var": "red",
                    "for": "orange",
                    "while": "orange",
                    "switch": "orange",
                    "case": "orange",
                    "break": "orange",
                    "continue": "orange",
                    "true": "brown",
                    "false": "brown",
                    "null": "brown",
                    "undefined": "brown",
                    "&lt;": "red",
                    "&gt;": "red",
                    "create": "blue",
                    "object": "brown",
                    "as": "purple",
                    "freetext": "brown",
                },
            }
        }
        return this.themedata;
    }
}
